
import CopyClipboard from "~/assets/svg/heroicons/copy-clipboard.svg?inline=1";

export default {
  components: {
    CopyClipboard,
  },
  props: {
    baidu: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    showDetail: {
      type: Boolean,
      required: true,
    },
    distance: {
      type: Number,
      required: false,
      default: null,
    },
    activeTab: {
      type: String,
      default: null,
    },
  },
  computed: {
    urlToMap() {
      return this.baidu
        ? `http://api.map.baidu.com/marker?location=${this.position.lat},${this.position.lng}&output=html&s=gibberish`
        : `https://www.google.com/maps/dir//${this.position.lat},${this.position.lng}`;
    },
  },
  methods: {
    async copyClipboard(text) {
      try {
        await this.$copyText(text);
        this.$toast.success(this.$t("common.copied_clipboard"));
      } catch (e) {
        console.error(e);
      }
    },
  },
};
